import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FolderOpen, Download, FileText } from 'lucide-react';
import PortalTopBar from '../../components/academy/PortalTopBar';
import { useAuth } from '../../context/AuthContext';

const API = (process.env.CRA_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL);

export default function Documents() {
  const { api } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/academy/my/documents')
      .then(({ data }) => setRows(data.rows || []))
      .finally(() => setLoading(false));
  }, [api]);

  const onDownload = async (id, filename) => {
    // Use authenticated download via cookies
    const res = await api.get(`/api/academy/my/documents/${id}`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <PortalTopBar />
      <main className="max-w-[1100px] mx-auto px-4 lg:px-6 py-8">
        <Link to="/academy/dashboard" className="inline-flex items-center gap-1.5 text-[13px] text-[#6E6E73] hover:text-[#c9a227] mb-4">
          <ArrowLeft className="w-3.5 h-3.5" /> Dashboard
        </Link>
        <h1 className="text-[28px] font-extrabold text-[#1D1D1F] mb-1">Document Management</h1>
        <p className="text-[14px] text-[#6E6E73] mb-6">Course materials, transcripts, and certificates posted by your admin.</p>

        {loading ? (
          <div className="text-[#6E6E73] text-[14px]">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-[#E5E5E7] bg-white p-10 text-center">
            <FolderOpen className="w-10 h-10 text-[#c9a227] mx-auto mb-3" />
            <div className="text-[16px] font-bold text-[#1D1D1F]">No documents yet</div>
            <p className="text-[13.5px] text-[#6E6E73]">When your admin uploads a file for you, it'll appear here.</p>
          </div>
        ) : (
          <ul className="rounded-2xl overflow-hidden border border-[#E5E5E7] bg-white divide-y divide-[#E5E5E7]">
            {rows.map((d) => (
              <li key={d.id} data-testid={`document-${d.id}`} className="px-5 py-4 flex items-center justify-between gap-4">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-10 h-10 rounded-lg bg-amber-50 border border-amber-200 flex items-center justify-center shrink-0">
                    <FileText className="w-5 h-5 text-[#c9a227]" />
                  </div>
                  <div className="min-w-0">
                    <div className="font-bold text-[#1D1D1F] truncate">{d.title}</div>
                    <div className="text-[12px] text-[#6E6E73] truncate">{d.filename} · {(d.size / 1024).toFixed(1)} KB</div>
                  </div>
                </div>
                <button
                  onClick={() => onDownload(d.id, d.filename)}
                  data-testid={`download-${d.id}`}
                  className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-[12.5px] font-bold uppercase tracking-wider text-[#0e0e10]"
                  style={{ background: 'linear-gradient(90deg,#e6c35a,#c9a227,#a8871a)' }}
                >
                  <Download className="w-3.5 h-3.5" /> Download
                </button>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
